<template>
  <div id="newsDetail" >
    <div class="newsDetail-top">
      <Header/>
      <div class="breadcrumb-bg">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
          <el-breadcrumb-item><router-link class="link-back" to="/">首頁</router-link></el-breadcrumb-item>
          <el-breadcrumb-item><router-link class="link-back" to="/news">最新資訊</router-link></el-breadcrumb-item>
          <el-breadcrumb-item class="current">{{newsTable.title}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="element animated fadeIn">
      <!-- <img src="../../images/sostenibilita.jpg"/> -->
      <img :src="url + newsTable.topImage" />
    </div>
    <div class="newsDetail-bottom animated fadeIn">
      <div class="box-ct">
        <div class="label">
          <span>
            <i class="iconfont">&#xe737;</i>
            <em>最新資訊</em>
          </span>
        </div>
        <router-link class="link-back" to="/news">
          <i class="iconfont">&#xe788;</i>返回最新資訊
        </router-link>
        <div class="box">
          <div class="h1">{{newsTable.title}}</div>
          <!-- <p>{{newsTable.createTime}}</p> -->
          <!-- <article v-html="newsTable.content"></article> -->
          <div class="ql-container ql-snow">
            <div class="ql-editor" v-html="newsTable.content">
              </div>
          </div>
        </div>
        <div class="box404" :hidden="hidden">
          <div class="h1">404</div>
          <div class="h2">新聞不存在</div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '../../components/Header.vue'      //公共头部
import Footer from '../../components/Footer.vue'      //底部
import { reqNewsDetail } from '../../untils/api.js'

import 'quill/dist/quill.snow.css'


export default {
  name: 'NewsDetail',
  data () {
    return {
      url: this.$store.state.baseURL + '/iveco/news/getNewsImge?fileName=',
      loadingUsergroupList: false,
      newsTable: {},
      hidden: true
    }
  },
  mounted () {
    console.log('this.$route.params.id', this.$route.params.id)
    
    let data = {
      id: this.$route.params.id
    }
    reqNewsDetail(data).then(res => {
      setTimeout(() => {
        this.loadingUsergroupList = true
      },1115000)
      if (res.code == 200) {
        let data = res.data.data
        if (data == null || data == '') {
          this.hidden = false
        } else {
          if (data.status == 1) {
            this.newsTable = data
          } else {
            this.hidden = false
          }
        }
        // console.log('this.newsTable', this.newsTable)
      }
    })
  },
  methods: {
    
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>
  .ql-container.ql-snow {
    border: none;
    .ql-editor {
      padding: 0;
    }
  }

  .box404 {
    text-align: center;
    .h1 {
      font-size: 30px;
      padding: 10px;
    }
    .h2 {
      font-size: 25px;
      padding: 10px;
    }
  }
  .el-breadcrumb__inner a {
    font-weight: normal; 
    &:hover {
      color: #606266;
    }
  }
  img{
    height: auto;
  }
  #newsDetail {
    background: #f4f4f4;
    position: relative;
    max-width: 1440px;
    margin: 0 auto;
    box-shadow: 0 0 16px #a6a6a6;
    // background: #f3f3f3;
    // height: auto;
    .newsDetail-top {
      width: 100%;
      // width: 1440px;
      position: fixed;
      top: 0;
      z-index: 99;
      .breadcrumb-bg {
        margin-top: 50px;
        box-shadow: 0 3px 2px rgba(0,0,0,0.1);
        background: #f3f3f3;
        .breadcrumb {
          padding: 10px 10px 6px !important;
        }
        .el-breadcrumb {
          font-size: 13px;
          line-height: 16px;
          padding: 10px 0;
          background: #f3f3f3;
          span {
            padding-bottom: 3px;
            &:last-of-type {
              width: 170px;
              display: inline-block;
              white-space: nowrap; 
              overflow: hidden;
              text-overflow:ellipsis;
            }
          }
        }
      }
    }
    .element {
      max-width: 100%;
      padding-top: 86px;
      margin-bottom: 10px;
      img {
        vertical-align: middle;
        margin: 0 auto;
      }
    }
    .newsDetail-bottom {
      width: 100%;
      // height: 100%;  
      padding-bottom: 32px;
      margin: 0 auto;
      // overflow: hidden;
      top: 0;
      position: relative;
      .box-ct {
        height: auto;
        padding: 45px 0 10px;
        margin-top: 10px;
        position: relative;
        z-index: 1;
        background-color: #FFFFFF;
        color: #545454;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        .label {
          // background-image: url(../images/box-label-corner.png);
          background-position: 0 0;
          background-repeat: no-repeat;
          left: -7px;
          padding-left: 0;
          padding-top: 5px;
          position: absolute;
          z-index: 5;
          max-width: 100%;
          top: 16px;
          &::before {
            content: '';
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 0 5px 7px;
            border-color: transparent transparent #666 transparent;
            position: absolute;
            top: -5px;
            left: 0;
          }
          span {
            z-index: 100;
            position: absolute;
            top: 0;
            background-color: #000000;
            color: #EBEBEB;
            height: 26px;
            line-height: 15px;
            /* max-width: 90%; */
            overflow: hidden;
            padding: 5px 10px 5px 10px;
            text-overflow: ellipsis;
            text-transform: uppercase;
            white-space: nowrap;
            display: block;
            border-radius: 0px;
            em {
              font-weight: 700;
              font-size: 13px;
              font-style: normal;
            }
          }
        }
        a.link-back {
          text-decoration: none;
          color: #555555;
          i {
            font-size: 12px;
            font-weight: 600;
            margin-right: 8px;
          }
          &.link-back {
            font-size: 13px;
            font-weight: bold;
            position: absolute;
            top: 20px;
            right: 20px;
            z-index: 5;
          }
        }
        .box {
          width: 100%;
          font-size: 12px;
          color: #545454;
          background-color: #FFFFFF;
          padding: 16px;
          vertical-align: top;
          white-space: normal;
          position: relative;
          .h1 {
            font-size: 26px;
            height: auto;
            line-height: 30px;
            margin-top: 20px;
            margin-bottom: 28px;
          }
          p {
            margin-bottom: 10px;
            margin-top: 8px;
            font-size: 13px;
            letter-spacing: 1px;
            /* font-weight: 600; */
            color: #727272;
          }
        }
      }
    }
  }
  a {
    color: #000;
    text-decoration: none;
    &:active {
      color: #000;
    }
  }


 

  @media (min-width: 768px) {
    #newsDetail {
      .newsDetail-top {
        .breadcrumb-bg {
          margin-top: 50px;
          .el-breadcrumb {
            span {
              &:last-of-type {
                width: 400px;
              }
            }
          }
        }
      }
      .element {
        padding-top: 86px;
      }
      .newsDetail-bottom {
        width: 750px;
      }
    }
  }

  @media (min-width: 992px) {
    #newsDetail {
      .newsDetail-top {
        .breadcrumb-bg {
          margin-top: 0;
          .el-breadcrumb {
            span {
              &:last-of-type {
                width: 600px;
              }
            }
          }
        }
      }
      .element {
        padding-top: 137px;
      }
      .newsDetail-bottom {
        width: 970px;
      }
    }
  }  

  @media (min-width: 1200px) {
    #newsDetail {
      .newsDetail-top {
        .breadcrumb-bg {
          margin-top: 0;
          .el-breadcrumb {
            span {
              &:last-of-type {
                width: auto;
              }
            }
          }
        }
      }
      .element {
        padding-top: 138px;
      }
      .newsDetail-bottom {
        width: 990px;
        .box-ct {

        }
      }
    }
  }

  @media (min-width: 1439px) {
    #newsDetail {
      .newsDetail-top{
        width: 1440px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/news/Detail.vue